module.exports = __webpack_public_path__ + "img/5dc26b3afc2ca639d42e6839c1453496.5a810675.jpg";